import React, { HTMLAttributes } from 'react'
import { styles } from './SliderSection.css'
import { PortableTextObject } from 'sanity'
import { ImageSlider } from '@otomoro/components/shared/ImageSlider'
import { SectionHeader } from "@otomoro/components/shared/SectionHeader"

interface SliderSectionProps extends HTMLAttributes<Element> {
	tag: string
	titleText: PortableTextObject
	description: PortableTextObject
	images: any[]
}

export const SliderSection: React.FC<SliderSectionProps> = ({
	tag,
	titleText,
	description,
	images,
}) => {
	const { base, figure, slide, sliderWrapper, image } = styles()

	return (
		<section className={base()}>
			<SectionHeader tag={tag} title={titleText} description={description} />
			<div className={sliderWrapper()}>
				<ImageSlider
					figureClassName={figure()}
					imageClassName={image()}
					slideClassName={slide()}
					images={images}
				/>
			</div>
		</section>
	)
}
